import { useEffect, useState } from "react";
import { QuerySummary as HeadlessQuerySummary } from "@coveo/headless";
import StickyHeader from "components/utility/sticky-header/StickyHeader";
import StickyHeaderContainer from "components/utility/sticky-header/StickyHeaderContainer";
import ImageArrow from "components/utility/images/ImageArrow";
import { setBodyPositionFixed } from "utils/dom";

type SearchPageMobileFiltersProps = {
	isMobile: boolean;
	mobileFilterCount: number;
	mobileSortBy: string;
	querySummary: HeadlessQuerySummary;
	toggleMobileFacetGroup: boolean;
	toggleMobileSort: boolean;
	setToggleMobileFacetGroup: React.Dispatch<React.SetStateAction<boolean>>;
	setToggleMobileSort: React.Dispatch<React.SetStateAction<boolean>>;
};

const SearchPageMobileFilters = ({
	isMobile,
	mobileFilterCount,
	mobileSortBy,
	querySummary,
	toggleMobileFacetGroup,
	toggleMobileSort,
	setToggleMobileFacetGroup,
	setToggleMobileSort
}: SearchPageMobileFiltersProps) => {
	const [state, setState] = useState(querySummary.state);
	useEffect(() => querySummary.subscribe(() => setState(querySummary.state)), [querySummary]);

	return (
		<>
			{isMobile && state.hasResults && (
				<StickyHeaderContainer>
					<StickyHeader>
						<div className="search-page-header-mobile-filters">
							<div className="home-browseby-bar-mobile-filter-button">
								<div
									aria-label="facet filter"
									className="home-browseby-bar-mobile-browseby"
									role="button"
									tabIndex={0}
									onClick={() => {
										setBodyPositionFixed();
										setToggleMobileFacetGroup(!toggleMobileFacetGroup);
									}}
									onKeyDown={() => {
										setBodyPositionFixed();
										setToggleMobileFacetGroup(!toggleMobileFacetGroup);
									}}
								>
									{"Filter"}
									<div
										className={`home-browseby-bar-mobile-filter-count ${
											mobileFilterCount ? "show" : ""
										}`}
									>
										{mobileFilterCount === 0 ? null : mobileFilterCount}
									</div>
								</div>
							</div>
							<div className="home-browseby-bar-mobile-filter-button">
								<div
									aria-label="sortby filter"
									className="home-browseby-bar-mobile-sortby"
									role="button"
									tabIndex={0}
									onClick={() => {
										setBodyPositionFixed();
										setToggleMobileSort(!toggleMobileSort);
									}}
									onKeyDown={() => {
										setBodyPositionFixed();
										setToggleMobileSort(!toggleMobileSort);
									}}
								>
									<div className="home-browseby-bar-mobile-sortby-label">{mobileSortBy}</div>
									<ImageArrow />
								</div>
							</div>
						</div>
					</StickyHeader>
				</StickyHeaderContainer>
			)}
		</>
	);
};

export default SearchPageMobileFilters;
